import { ChangeDetectorRef, Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsBuilderPolishedService } from '../services/forms-builder-polished.service';
import { FormsService } from '../../forms.service';
import {FormVersionConfigurationModel} from '../../../../models/forms/form-version-configuration.model';
import {FormConfigurationModel} from '../../../../models/forms/form-configuration.model';

@Component({
  standalone: false,
  selector: 'app-forms-builder-polished-form-creation',
  templateUrl: './forms-builder-polished-form-creation.component.html',
  styleUrls: ['./forms-builder-polished-form-creation.component.css']
})
export class FormsBuilderPolishedFormCreationComponent implements OnInit, OnDestroy {

  private isDestroyed = false;
  mode: string = '';
  subMode: string = '';
  searchFormSubscription: any;
  formSearchResults: any[];
  existingVersions: any[];
  isSearchingForForms: boolean = false;
  selectedFormPreview: any;
  newFormName: string = '';
  selectedFormId: string;

  constructor(
    private builderService: FormsBuilderPolishedService,
    private formsService: FormsService,
    public dialogRef: MatDialogRef<FormsBuilderPolishedFormCreationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnDestroy() {
    this.isDestroyed = true;
    if (this.searchFormSubscription) {
      this.searchFormSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.mode = this.data.mode;
    if (this.data.existingVersions) {
      this.existingVersions = this.data.existingVersions;
    }
  }

  initDuplicateMode() {
    this.subMode = 'duplicate';
    // fetch list of existing forms
  }

  searchForForm(keyword: string) {
    keyword = keyword.trim();
    this.selectedFormId = null;

    this.isSearchingForForms = true;
    if (this.searchFormSubscription) {
      this.searchFormSubscription.unsubscribe();
    }

    if (!keyword) {
      this.formSearchResults = null;
      this.isSearchingForForms = false;
      return;
    }

    this.searchFormSubscription = this.builderService.searchForFormByKeyword(keyword)
      .subscribe((response) => {
        this.searchFormSubscription = null;
        this.isSearchingForForms = false;
        this.formSearchResults = response.sort((a, b) => {
          let keywordIndexA = a.DFormName.toLowerCase().indexOf(keyword.toLowerCase());
          let keywordIndexB = b.DFormName.toLowerCase().indexOf(keyword.toLowerCase());
          return keywordIndexA - keywordIndexB;
        });
        if (!this.isDestroyed) this.cdr.detectChanges();
      }, err => {
        this.searchFormSubscription = null;
        this.isSearchingForForms = false;
        if (!this.isDestroyed) this.cdr.detectChanges();
        console.log(err);
      });
  }

  selectCfgForm(formPreview) {
    this.selectedFormId = formPreview.DFormId;
    this.selectedFormPreview = formPreview;
  }

  submitDuplicateForm(selectedFormPreview) {
    this.dialogRef.close({
      proceed: true,
      mode: 'duplicate',
      selectedForm: selectedFormPreview,
      DFormName: this.newFormName,
    });
  }

  submitNewForm() {
    this.dialogRef.close({
      proceed: true,
      mode: 'create',
      DFormName: this.newFormName
    });
  }

  submitNewVersion() {
    this.dialogRef.close({
      proceed: true,
      mode: 'create',
    })
  }

  selectCfgVersion(selectedVersion: FormVersionConfigurationModel) {
    this.dialogRef.close({
      proceed: true,
      mode: this.subMode,
      versionID: selectedVersion.DFormVersionId,
    });
  }

  close() {
    this.dialogRef.close(false);
  }

  deleteForm() {
    this.dialogRef.close({
      proceed: true,
      mode: 'delete',
    });
  }

}

